module.exports = __webpack_public_path__ + "static/media/7.5522e56c.jpg";